import './TaxonomyMapperReview.scss';
import React from "react";
import {observer} from "mobx-react-lite";
import {generatePath, useLocation, useNavigate, useParams} from "react-router";
import type {DatabagRouteMatch} from "../../routing/catRoutes";
import {routes} from "../../routing/routes";
import {useStores} from "../../stores";
import {Button, Grid} from "@mui/material";
import {KoiFacade} from "../../components/koi-facade/KoiFacade";
import Typography from "@mui/material/Typography";
import {TaxonomyMapperReviewTable} from "./table/TaxonomyMapperReviewTable";
import {ChevronRight} from "@mui/icons-material";
import {TaxonomyMapperUnmappedReviewTable} from "./table/TaxonomyMapperUnmappedReviewTable";
import {environment} from "../../env";
import {generateGotoDashboardPath} from "../../routing/routing.utils";

export const TaxonomyMapperReviewPage: React.FC = observer(() => {
    const {p, rootAppStore, taxonomyMapperStore} = useStores();
    const params = useParams<DatabagRouteMatch>();
    const location = useLocation();
    const navigate = useNavigate();
    // const theme = useTheme();
    // const mediaTablet = useMediaQuery(theme.breakpoints.down('md'));

    let backUrl;
    if (environment.package === 'sales_demo') {
        backUrl = generatePath(routes.demo_merge_taxonomy_mapper, params);
    } else {
        throw new Error('Not implemented');
    }
    // TODO: CAT-712
    // rootAppStore.app.dashEnv === 'simple'
    //     ? generatePath(routes.pic_common_categories, params)
    //     : rootAppStore.app.dashEnv === 'nestle'
    //         ? generatePath(routes.nestle_common_categories, params)
    //         : generatePath(routes.synergy_v2_taxonomy_mapper, params)

    const toDashboard = Boolean(p.p.skipAiTaxonomyMapperModel);
    if (!toDashboard) console.warn('Submiting the data is not supported yet...');

    return (
        <KoiFacade
            title="Taxonomy Mapper Review"
            // helpContent={<PurchasePriceVarianceHelp/>}
            intro={<></>}
            back={backUrl}
            next={{
                type: 'component',
                node: <Button
                    color="primary"
                    variant="outlined"
                    endIcon={<ChevronRight/>}
                    onClick={() => navigate(generateGotoDashboardPath(location, params))}>
                    Dashboard
                </Button>
            }}
            className="taxonomy-mapper-review-page">

            <section className="unmatched">
                <header>
                    <Typography variant="h2" className="title">
                        Not matched categories
                    </Typography>
                    <Typography variant="body1" className="explanation">
                        The categories below are not matched to an existing category.
                        You can still continue with the review process.
                        However, the entries associated with these categories will either be assigned as Uncategorized
                        or receive an Ai suggested category.
                    </Typography>
                </header>

                <TaxonomyMapperUnmappedReviewTable/>

            </section>

            <section className="matched">
                <header>
                    <Typography variant="h2" className="title">
                        Matched categories
                    </Typography>
                    <Grid container justifyContent="end" className="taxonomy-titles">
                        <Grid
                            size={{
                                sm: 6
                            }}>
                            <Typography variant="h3" className="taxonomy-title base-title">
                                {taxonomyMapperStore.baseTaxonomyName}
                            </Typography>
                        </Grid>
                        <Grid
                            size={{
                                sm: 6
                            }}>
                            <Typography variant="h3" className="taxonomy-title target-title">
                                {taxonomyMapperStore.targetTaxonomyName}
                            </Typography>
                        </Grid>
                    </Grid>
                </header>

                <TaxonomyMapperReviewTable/>
            </section>
        </KoiFacade>
    );
});
